import { createStore } from 'owa-satcheljs';
import type { OwaDate } from 'owa-datetime';

export type CalendarSchedulingEntrySource = 'SurfaceContextMenu' | 'NewButton';

export interface SchedulingTimeRange {
    start: OwaDate;
    end: OwaDate;
}

export interface CalendarSchedulingDialogStoreSchema {
    isOpen: boolean;
    entrySource?: CalendarSchedulingEntrySource;
    timeRange?: SchedulingTimeRange;
}

const store: CalendarSchedulingDialogStoreSchema = {
    isOpen: false,
};

export const getStore: () => CalendarSchedulingDialogStoreSchema =
    createStore<CalendarSchedulingDialogStoreSchema>('CalendarSchedulingDialogStore', store);
